import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { IonSpinner } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import {
  brandOverride,
  getProductByModelIdentifier,
  isConnect,
  isMaster,
} from '../../../../../ECoSystemsHelper';
import {
  CPSConfigFunctionnalityGraphiques,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
} from '../../../../IProduct';
import { DateInterval } from '../../../../../../../components/input-dateinterval/input-dateinterval.component';
import {
  DataProductType,
  PoolDataApi,
} from '../../../../../../../apis/poolData.api';
import { PoolEventsApi } from '../../../../../../../apis/poolEvent.api';
import { Chart, registerables } from 'chart.js';
import { AppComponent } from '../../../../../../../app.component';
import {
  convertSecondsToHM,
  convertSecondsToTime,
  getModeFromStartAndEndDate,
} from '../../../../../helper/convertSecondsToTime';
import moment from 'moment/moment';

@Component({
  selector: 'app-p00076-function-history-graph',
  templateUrl: './p00076-function-history-graph.component.html',
  styleUrls: ['./p00076-function-history-graph.component.scss'],
  imports: [IonSpinner, TranslatePipe],
})
export class P00076FunctionHistoryGraphComponent
  implements OnInit, OnDestroy, AfterViewInit, OnChanges
{
  @Input() poolId: string | null = null;
  @Input() config: CPSConfigFunctionnalityGraphiques | null = null;
  @Input() dateInterval: DateInterval | null = null;

  private poolDataApi = inject(PoolDataApi);
  private poolEventApi = inject(PoolEventsApi);

  @ViewChild('chart', { static: false })
  chartRef!: ElementRef<HTMLCanvasElement>;
  private chart: any = null;

  public isLoading = true;
  public totalValue: string | null = null;
  public totalValue2: string | null = null;

  constructor() {
    Chart.register(...registerables);
  }

  ngOnInit() {
    console.log('todo', this.config, this.dateInterval);
  }

  getCurrentMode() {
    return getModeFromStartAndEndDate(
      Math.floor(this.dateInterval!.startTimestamp! / 1000),
      Math.floor(this.dateInterval!.endTimestamp! / 1000),
    );
  }

  calculTotal(datas: any = []) {
    let res = 0;

    for (let i = 0; i < datas.length; i++) {
      if (datas[i].value > 0) {
        res = res + datas[i].value;
      }
    }

    let res2 = 0;

    for (let i = 0; i < datas.length; i++) {
      if (datas[i].value2 < 0) {
        res2 = res2 + datas[i].value2;
      }
    }

    this.totalValue = Number(res).toFixed(1) + 'm3';
    this.totalValue2 = Number(Math.abs(res2)).toFixed(1) + 'm3';
  }

  refreshDatas() {
    this.isLoading = true;

    const productClass = getProductByModelIdentifier(
      this.config?.modelIdentifier,
    );

    let productType = DataProductType.PRODUCT;

    if (isMaster(productClass!)) {
      productType = DataProductType.MASTER;
    } else if (isConnect(productClass!)) {
      productType = DataProductType.CONNECT;
    }

    if (this.config!.mode == HistoryGraphModeEnum.DATA) {
      this.poolDataApi
        .getPoolProductDatasProperties(
          this.poolId!,
          productType,
          productClass!.modelIdentifier!,
          this.config!.customGraph.properties!,
          this.config!.aggregate!,
          Math.floor(this.dateInterval!.startTimestamp! / 1000),
          Math.floor(this.dateInterval!.endTimestamp! / 1000),
        )
        .then((productDatas) => {
          this.createBarChart(productDatas);

          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  ngAfterViewInit() {
    if (this.chartRef && this.chartRef.nativeElement) {
      this.refreshDatas();
    }
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Vérifier si dateInterval a changé
    if (changes['dateInterval'] && !changes['dateInterval'].firstChange) {
      if (this.chartRef && this.chartRef.nativeElement) {
        this.refreshDatas();
      }
    }
  }

  private getMonthOrDay(options: any, propName: string): number {
    if (!options) {
      return options;
    }

    if (
      this.getCurrentMode() === 'day' &&
      (options[propName + 'Mensuel'] != null ||
        options[propName + 'Mensuel'] != undefined)
    ) {
      return options[propName + 'Mensuel'];
    }

    return options[propName];
  }

  private getMinMaxValues(
    data: any[] = [],
    min = 0,
    max = 1,
  ): { min: number; max: number } {
    if (
      this.getMonthOrDay(this.config?.yModeOptions, 'min') ||
      this.getMonthOrDay(this.config?.yModeOptions, 'max')
    ) {
      // Si des données sont présentes, calculer les valeurs réelles
      if (data && data.length > 0) {
        const values = data
          .map((item) => item.value)
          .filter((val) => val !== null && val !== undefined && val !== -100);

        const valuesMin = data
          .map((item) => item.value2)
          .filter((val) => val !== null && val !== undefined && val !== -100);

        if (values.length > 0) {
          const dataMax = Math.max(...values);
          const dataMin = Math.min(...valuesMin);

          // Gestion du max avec la subtilité demandée
          const configMin = this.getMonthOrDay(
            this.config?.yModeOptions,
            'min',
          );
          if (configMin !== undefined) {
            // Si une valeur dans les données est supérieure au max configuré, utiliser la valeur maximum des données
            min = dataMin < configMin ? dataMin : configMin;
          } else {
            min = dataMin;
          }

          // Gestion du max avec la subtilité demandée
          const configMax = this.getMonthOrDay(
            this.config?.yModeOptions,
            'max',
          );
          if (configMax !== undefined) {
            // Si une valeur dans les données est supérieure au max configuré, utiliser la valeur maximum des données
            max = dataMax > configMax ? dataMax : configMax;
          } else {
            max = dataMax;
          }
        }
      } else {
        // Si pas de données, utiliser les valeurs de configuration ou les valeurs par défaut
        min =
          this.getMonthOrDay(this.config?.yModeOptions, 'min') !== undefined
            ? this.getMonthOrDay(this.config?.yModeOptions, 'min')
            : min;
        max =
          this.getMonthOrDay(this.config?.yModeOptions, 'max') !== undefined
            ? this.getMonthOrDay(this.config?.yModeOptions, 'max')
            : max;
      }
    }

    return { min, max };
  }

  private createBarChart(datasToNotUse: any = []) {
    const ctx = this.chartRef.nativeElement.getContext('2d');
    if (!ctx) return;

    const datas = datasToNotUse.coSVolumeEauRempli;

    for (let i = 0; i < datas.length; i++) {
      datas[i].value = datas[i].value / 100;
      datas[i].value2 = -datasToNotUse.coSVolumeEauVidange[i].value / 100;
    }

    this.calculTotal(datas);

    // Créer les labels et les données à partir des données filtrées
    const labels = datas.map((item: any) => {
      return item.date;
    });

    const data = datas.map((item: any) => (item.value > 0 ? item.value : 0));
    const data2 = datas.map((item: any) => (item.value2 < 0 ? item.value2 : 0));

    if (this.chart) {
      this.chart.destroy();
    }

    const mode = this.getCurrentMode();
    const { min, max } = this.getMinMaxValues(datas, -100, 100);

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor:
              AppComponent.currentBrand?.getMainColor() ?? '#F39200',
            borderColor: AppComponent.currentBrand?.getMainColor() ?? '#F39200',
            borderWidth: 1,
            barPercentage: 0.9,
            categoryPercentage: 0.9,
          },
          {
            data: data2,
            backgroundColor: '#0095F2',
            borderColor: '#0095F2',
            borderWidth: 1,
            barPercentage: 0.9,
            categoryPercentage: 0.9,
          },
        ],
      },
      options: {
        responsive: true,
        animation: false,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              title: (context: any) => {
                const index = context[0].dataIndex;
                const originalItem = labels[index];
                return moment(originalItem).format('DD/MM/YY HH:mm');
              },
              label: (context: any) => {
                const value = context.parsed.y;
                return this.convertValue(value as any) as any;
              },
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            min: min,
            max: max,

            grid: {
              display: true,
              color: '#C5CBD8',
            },

            ticks: {
              maxRotation: 0, // Désactiver la rotation
              minRotation: 0, // Désactiver la rotation
              autoSkip: false,

              callback: (value: any) => {
                return this.convertValue(value as any);
              },
            },
          },
          x: {
            stacked: true,

            grid: {
              display: false,
            },
            ticks: {
              maxRotation: 0, // Désactiver la rotation
              minRotation: 0, // Désactiver la rotation
              autoSkip: true, // Activer le masquage automatique
              autoSkipPadding: 10, // Padding entre les labels visibles

              callback: function (value: string | number) {
                if (mode === 'day') {
                  const date = moment(labels[value as number]).format('DD/MM');
                  const time = moment(labels[value as number]).format('YY');

                  return [date, time];
                } else if (mode === 'month') {
                  return moment(labels[value as number]).format('MM/YY');
                }

                if (
                  ['00', '06', '12', '18'].indexOf(
                    moment(labels[value as number]).format('HH'),
                  ) > -1
                ) {
                  const date = moment(labels[value as number]).format('DD/MM');
                  const time =
                    moment(labels[value as number]).format('HH') + 'h';

                  return [time, date];
                } else if (labels.length <= 50) {
                  const time =
                    moment(labels[value as number]).format('HH') + 'h';
                  return [time];
                }

                return undefined;
              },
            },
          },
        },
      },
    });
  }

  convertValue(value: number) {
    return Math.abs(value) + 'm3';
  }

  protected readonly getProductByModelIdentifier = getProductByModelIdentifier;
  protected readonly brandOverride = brandOverride;
}
